const CONTROL_CHARS = /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g;
const PROTOTYPE_KEYS = new Set(["__proto__", "prototype", "constructor"]);

export function sanitizeStateString(value: string, maxLength = 4000): string {
  return value.replace(CONTROL_CHARS, "").trim().slice(0, maxLength);
}

export function sanitizeStateValue(value: unknown, depth = 0): unknown {
  if (depth > 12) throw new Error("状态值嵌套过深");
  if (typeof value === "string") return sanitizeStateString(value);
  if (typeof value === "number") {
    if (!Number.isFinite(value)) throw new Error("状态数值必须有限");
    return value;
  }
  if (typeof value === "boolean" || value === null) return value;
  if (Array.isArray(value))
    return value
      .slice(0, 200)
      .map((entry) => sanitizeStateValue(entry, depth + 1));
  if (typeof value === "object") {
    const result: Record<string, unknown> = {};
    for (const [key, entry] of Object.entries(
      value as Record<string, unknown>,
    )) {
      if (PROTOTYPE_KEYS.has(key)) continue;
      result[sanitizeStateString(key, 100)] = sanitizeStateValue(
        entry,
        depth + 1,
      );
    }
    return result;
  }
  throw new Error(`不支持的状态值类型：${typeof value}`);
}

export function sanitizeTaskStatus(status: unknown): "available" {
  void status;
  return "available";
}
